export const LOGEMENT_LESSONS_PT = [
  {
    id: 'logement-1',
    numero: 1,
    titre: "Compreender o pedido de habitação social",
    sousTitre: "Um formulário nacional único",
    contexte: "Quer obter uma habitação social. Como funciona o sistema e como fazer o pedido?",
    explication: [
      "**O pedido nacional único**: em França, existe um único formulário de pedido para todas as habitações sociais — apresentado uma só vez.",
      "**O número de registo único**: após o pedido, recebe um número único (numéro unique) que comprova a data do pedido e a sua prioridade.",
      "**O site oficial**: demande-logement-social.gouv.fr — completamente gratuito. Desconfie de sites privados que cobram dinheiro.",
      "**Critérios de prioridade**: situação familiar, nível de rendimento, situação habitacional actual (despejo, sobrelotação...) influenciam a prioridade.",
      "**Renovação do pedido**: todos os anos deve renovar o pedido ou será automaticamente cancelado. Coloque um lembrete no telemóvel.",
    ],
    question: "Onde deve fazer o pedido de habitação social?",
    options: [
      { id: 'a', text: "Em demande-logement-social.gouv.fr — gratuitamente", correct: true },
      { id: 'b', text: "Em sites imobiliários privados como SeLoger", correct: false },
      { id: 'c', text: "Na câmara municipal de cada bairro separadamente", correct: false },
    ],
    explication_reponse: "O site oficial e único é demande-logement-social.gouv.fr — completamente gratuito. Qualquer outro site que cobre dinheiro para fazer o pedido de habitação social é uma fraude.",
  },
  {
    id: 'logement-2',
    numero: 2,
    titre: "Fazer o pedido online",
    sousTitre: "Passo a passo",
    contexte: "O pedido electrónico é simples se tiver os documentos certos. Veja como fazê-lo.",
    explication: [
      "**Documentos necessários**: documentos de identidade de todos os membros do agregado, comprovativo de rendimento ou aviso de imposto, comprovativo CAF se for beneficiário.",
      "**Preencher o formulário**: introduza as informações com cuidado — número de divisões pretendidas, zonas preferidas, situação actual.",
      "**Comprovativo imediato**: após o envio recebe imediatamente um comprovativo com o número de registo único — guarde-o com cuidado.",
      "**Alteração possível**: pode alterar o pedido em qualquer altura no site — adicionar cidades, mudar o tipo de habitação...",
      "**Acompanhamento do processo**: entre no site para acompanhar o estado do pedido e actualizar as informações quando necessário.",
    ],
    question: "O que recebe imediatamente após submeter o pedido de habitação social?",
    options: [
      { id: 'a', text: "Um comprovativo com o número de registo único", correct: true },
      { id: 'b', text: "Uma lista de habitações disponíveis imediatamente", correct: false },
      { id: 'c', text: "Uma marcação para visitar uma habitação social", correct: false },
    ],
    explication_reponse: "O número de registo único é o mais importante — comprova a data do pedido e a sua prioridade. Guarde-o num local seguro.",
  },
  {
    id: 'logement-3',
    numero: 3,
    titre: "Os apoios ao alojamento APL",
    sousTitre: "Tem direito?",
    contexte: "Paga renda. Pode ter direito ao APL da CAF para reduzir os custos de habitação.",
    explication: [
      "**APL** (Aide Personnalisée au Logement): ajuda mensal paga pela CAF a inquilinos com rendimento limitado.",
      "**Pago directamente ao senhorio**: na maioria dos casos, a CAF paga o APL directamente ao seu senhorio, e paga apenas a diferença.",
      "**Simulação**: em caf.fr → 'Simular o APL' — resultado imediato para saber se tem direito e o montante da ajuda.",
      "**Condições essenciais**: a habitação deve ser a sua residência principal, o senhorio deve ter um acordo com a CAF.",
      "**Não declarar alterações**: se mudar de casa ou a situação mudar sem avisar a CAF, esta pedirá o reembolso dos montantes pagos.",
    ],
    question: "A quem paga a CAF o APL na maioria dos casos?",
    options: [
      { id: 'a', text: "Directamente ao senhorio, e paga apenas a diferença", correct: true },
      { id: 'b', text: "A si pessoalmente todos os meses", correct: false },
      { id: 'c', text: "À câmara municipal que depois distribui", correct: false },
    ],
    explication_reponse: "O APL é normalmente pago directamente ao senhorio — garante ao senhorio receber a renda e ao inquilino uma redução automática. Paga apenas o que falta.",
  },
  {
    id: 'logement-4',
    numero: 4,
    titre: "Em caso de problema habitacional",
    sousTitre: "Os seus direitos e recursos de ajuda",
    contexte: "Despejo, conflito com o senhorio, habitação degradada... há soluções. Não está sozinho.",
    explication: [
      "**ADIL** (Agência de Informação sobre Habitação): aconselhamento jurídico gratuito sobre os seus direitos em matéria de habitação — encontre a ADIL em anil.org.",
      "**A trégua de inverno**: entre 1 de Novembro e 31 de Março, o despejo é proibido por lei em França mesmo sem pagar renda.",
      "**IRL** (Índice de Referência das Rendas): define o limite máximo de aumento de renda pelo senhorio — publicado trimestralmente pelo INSEE.",
      "**FSL** (Fundo de Solidariedade para a Habitação): ajuda para pessoas com dificuldade em pagar a renda — pedir através da câmara ou da CAF.",
      "**Habitação degradada**: se a sua habitação representa um risco (humidade, frio, insectos), contacte a câmara ou ligue para 0806 000 515.",
    ],
    question: "Quando está em vigor a trégua de inverno que proíbe os despejos?",
    options: [
      { id: 'a', text: "De 1 de Novembro a 31 de Março", correct: true },
      { id: 'b', text: "De 1 de Dezembro a 28 de Fevereiro", correct: false },
      { id: 'c', text: "Durante todo o ano para famílias com filhos", correct: false },
    ],
    explication_reponse: "A trégua de inverno vai de 1 de Novembro a 31 de Março — 5 meses por ano. Durante este período, nenhum inquilino pode ser despejado independentemente das circunstâncias.",
  },
];
